var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vehicle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/VehicleSmall",
    fill: "#6C7DBC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.13625,4.7915625 C18.93,4.183125 18.3525,3.75 17.671875,3.75 L6.328125,3.75 C5.6475,3.75 5.0803125,4.183125 4.86375,4.7915625 L2.8321875,10.63875 C2.76,10.8553125 2.71875,11.0821875 2.71875,11.319375 L2.71875,18.703125 C2.71875,19.5590625 3.4096875,20.25 4.265625,20.25 C5.1215625,20.25 5.8125,19.5590625 5.8125,18.703125 L5.8125,18.1875 L18.1875,18.1875 L18.1875,18.703125 C18.1875,19.54875 18.8784375,20.25 19.734375,20.25 C20.58,20.25 21.28125,19.5590625 21.28125,18.703125 L21.28125,11.319375 C21.28125,11.0925 21.24,10.8553125 21.1678125,10.63875 L19.13625,4.7915625 Z M6.328125,15.09375 C5.4721875,15.09375 4.78125,14.4028125 4.78125,13.546875 C4.78125,12.6909375 5.4721875,12 6.328125,12 C7.1840625,12 7.875,12.6909375 7.875,13.546875 C7.875,14.4028125 7.1840625,15.09375 6.328125,15.09375 Z M17.671875,15.09375 C16.8159375,15.09375 16.125,14.4028125 16.125,13.546875 C16.125,12.6909375 16.8159375,12 17.671875,12 C18.5278125,12 19.21875,12.6909375 19.21875,13.546875 C19.21875,14.4028125 18.5278125,15.09375 17.671875,15.09375 Z M4.78125,9.9375 L6.0909375,5.998125 C6.2353125,5.585625 6.6271875,5.296875 7.070625,5.296875 L16.929375,5.296875 C17.3728125,5.296875 17.7646875,5.585625 17.9090625,5.998125 L19.21875,9.9375 L4.78125,9.9375 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleSmall);
export default __webpack_public_path__ + "static/media/VehicleSmall.6c67ac86c7a786e28ef2508b231b517a.svg";
export { ForwardRef as ReactComponent };